import { useSearchParams } from 'react-router-dom';

export function formatDateTime(value) {
  if (!value || !Number.isFinite(new Date(value).getTime())) return '—';
  return new Date(value).toLocaleString('zh-CN', { timeZone: 'Asia/Shanghai', hour12: false });
}

export function useRecordView(keys) {
  const [searchParams, setSearchParams] = useSearchParams();
  const filters = Object.fromEntries(keys.map(key => [key, searchParams.get(key) || '']));
  const page = Math.max(1, Math.min(100000, Math.floor(Number(searchParams.get('page'))) || 1));
  const size = Number(searchParams.get('limit'));
  const pageSize = [10, 20, 50, 100].includes(size) ? size : 20;
  const update = (values, resetPage = true) => setSearchParams(previous => {
    const next = new URLSearchParams(previous);
    Object.entries(values).forEach(([key, value]) => value ? next.set(key, String(value)) : next.delete(key));
    if (resetPage) next.delete('page');
    return next;
  }, { replace: true });
  return {
    filters, page, pageSize, detailId: searchParams.get('detail'),
    params: { ...Object.fromEntries(Object.entries(filters).filter(([, value]) => value)), page, limit: pageSize },
    update, clear: () => setSearchParams({}, { replace: true }),
    openDetail: id => setSearchParams(previous => { const next = new URLSearchParams(previous); next.set('detail', id); return next; }),
    closeDetail: () => setSearchParams(previous => { const next = new URLSearchParams(previous); next.delete('detail'); return next; }, { replace: true })
  };
}

export const processingLabels = {
  received: '已接收，等待处理', ignored: '未进入处理', extracting: '正在识别',
  processing: '匹配并提交中', sent: '历史推送已受理', accepted: '伙伴通已接收', unknown: '接收结果待确认',
  partial: '部分已接收', failed: '处理失败', needs_review: '待完善报名信息'
};
